const scratchBlocks = ['motion_', 'looks_', 'sound_', 'sensing_', 'event_', 'control_delete_this_clone',
    'control_create_clone_of', 'control_start_as_clone', 'control_stop', 'music_', 'pen_', 'videoSensing_',
    'translate_', 'text2speech_', 'ev3_', 'boost_', 'wedo2_'];

const arduinoBlocks = ['data_string', 'romeo\.romeo_programstart', 'arduino\.arduino_uno_functions',
    'vortex\.vortexSetUp', 'vortex\.vortex_setExpression',
    'vortex\.vortex_readSensor', 'romeo\.romeo_printstring',
    'romeo\.romeo_readserialdata', 'romeo\.romeo_havenumberread',
    'romeo\.romeo_setbaudrate', 'arduino\.arduino_set_serial',
    'arduino\.arduino_havenumberread', 'arduino\.arduino_readserialdata',
    'arduino\.arduino_serial_send', 'microbit\.microbit_functions',
    'microbit\.microbitPrintStr', 'microbit\.microbitHaveDataRead',
    'microbit\.microbitReadSerialData', 'microbit\.microbitSetBaud',
    'microbit\.microbitControlLightBrightness','microbit\.microbitConsolePrint',
    'maqueen\.maqueenStarts','maqueen\.microbitPrintStr',
    'maqueen\.microbitHaveDataRead','maqueen\.microbitReadSerialData',
    'maqueen\.microbitSetBaud','maqueen\.microbitControlLightBrightness',
    'maqueen\.microbitConsolePrint',
    'leonardo\.leonardo_functions', 'leonardo\.leonardo_serial_send',
    'leonardo\.leonardo_havenumberread', 'leonardo\.leonardo_readserialdata',
    'leonardo\.leonardo_set_serial','arduinounoR3\.arduinounoR3_functions', 
    'arduinounoR3\.arduinounoR3_printstring','arduinounoR3\.arduinounoR3_havenumberread', 
    'arduinounoR3\.arduinounoR3_readserialdata','arduinounoR3\.arduinounoR3_setbaudrate',
    'maxbot\.maxbotConsolePrint','maxbot\.maxbotPrintStr',
    'maxbot\.maxbotHaveDataRead','maxbot\.maxbotReadSerialData',
    'maxbot\.maxbotSetBaud',
    'arduinonano\.arduinoNano_functions','arduinonano\.arduinoNano_serial_send', 
    'arduinonano\.arduinoNano_havenumberread','arduinonano\.arduinoNano_set_serial',
    'arduinonano\.arduinoNano_readserialdata','maxbot\.microbit_functions',
    'maxbot\.microbit_functions',
    'max\.maxStarts', 'max\.maxPrintStr','max\.maxHaveDataRead',
    'max\.maxReadSerialData','max\.maxSetBaud', 'operator_gt_equals','operator_lt_equals',
    'oled\.displayInLine','oled\.displayInXY','oled\.clear',
    'esp32.esp32_functions','esp32.esp32_serialSend','esp32.esp32_havenumberread',
    'esp32.esp32_readserialdata','esp32.esp32_setSerial','esp32.esp32_seriaRemapping',
    'esp32.esp32_screenDisplay','esp32.esp32_playMusicNow','esp32.esp32_consoleprint',
    'esp32.esp32_colorLed','esp32.esp32_forMpyDisplayInXY','esp32.esp32_forMpyImageDrawing',
    'esp32.esp32_forMpyFillScreen','esp32.esp32_forMpySetLightsColor',
    ];
const micropythonBlocks = [];

/**
 * 分析projectJson, 返回是哪个页面
 * @param {object} json 项目json文件
 * @returns {number} 0 解释执行, 1 上传执行
 */
export const getPageFromTargets = function (json: any) {
    if (!json.targets) {
        return 0;
    }
    if (json.targets.length > 2) {
        return 0;
    }else{
        return parseBlocks(json.targets);
    }
}
/**
 * 根据Targets分析block
 * @param {array} targets 角色数组
 * @returns {number} 返回页面信息
 */
function parseBlocks (targets: any) {
    let result: any = null;
    targets.forEach((item: any) => {
        if(!item.isStage){
            for(let id in item.blocks){
                if(!item.blocks[id].shadow){
                    let opcode = item.blocks[id].opcode;
                    // 如果存在arudino模式的积木
                    if(arduinoBlocks.indexOf(opcode) !== -1){
                        result = 1;
                        return;
                    }
                    let startOpcode = '';
                    if (opcode.indexOf('.') === -1) {
                        startOpcode = opcode.slice(0, opcode.indexOf('_') + 1);
                    } else {
                        startOpcode = opcode.slice(0, opcode.indexOf('.') + 1);
                    }
                    // 如果存在scratch原生积木
                    if((scratchBlocks.indexOf(startOpcode) !== -1) || (scratchBlocks.indexOf(opcode) !== -1)){
                        result = 0;
                        return;
                    }
                }
            }
        } else {
            // 舞台target 并且 存在背景blocks
            if (Object.keys(item.blocks).length > 0) {
                result = 0;
                return;
            }
        }
    });
    return result;
}